import firebase from '@/plugins/firebase'

var storage = firebase.storage()

export default storage